import React from "react";
import { Box, Typography } from "@mui/material";
import { UISitterProfileDisplay } from "types/ui.sitter.types";

interface CancellationPolicyProps {
  policy: UISitterProfileDisplay["cancellationPolicy"];
}

const CancellationPolicy: React.FC<CancellationPolicyProps> = ({ policy }) => {
  return (
    <Box
      sx={{
        backgroundColor: "white",
        borderRadius: 2,
        p: 3,
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      }}
    >
      {/* Header */}
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
        Cancellation Policy
      </Typography>

      {/* Policy Type */}
      <Typography
        variant="body1"
        sx={{
          fontWeight: 700,
          mb: 1.5,
          color: "#178B8E",
        }}
      >
        {policy.type}
      </Typography>

      {/* Policy Description */}
      <Typography
        variant="body2"
        sx={{
          color: "#5A5A5A",
          lineHeight: 1.7,
          whiteSpace: "pre-line",
        }}
      >
        {policy.description}
      </Typography>
    </Box>
  );
};

export default CancellationPolicy;
